import type { HTMLProps } from 'react';
import { forwardRef } from 'react';
import {
  FloatingFocusManager,
  FloatingPortal,
  useMergeRefs,
} from '@floating-ui/react';
import { usePopoverContext } from './context';

export const PopoverContent = forwardRef<
  HTMLDivElement,
  HTMLProps<HTMLDivElement>
>((props, propRef) => {
  const {
    context: floatingContext,
    refs,
    y,
    x,
    open,
    strategy,
    getFloatingProps,
    modal,
    onOpenChange,
    autoClose = false,
  } = usePopoverContext();

  const ref = useMergeRefs([refs.setFloating, propRef]);

  const handleClose = () => {
    if (autoClose) {
      onOpenChange(false);
    }
  };

  return (
    <FloatingPortal>
      {open ? (
        <FloatingFocusManager context={floatingContext} modal={modal}>
          <div
            ref={ref}
            {...getFloatingProps(props)}
            onClick={handleClose}
            onKeyDown={handleClose}
            role="button"
            style={{
              position: strategy,
              top: y ?? 0,
              left: x ?? 0,
              width: 'max-content',
              zIndex: 10,
              ...props.style,
            }}
            tabIndex={0}
          >
            {props.children}
          </div>
        </FloatingFocusManager>
      ) : null}
    </FloatingPortal>
  );
});

PopoverContent.displayName = 'PopoverContent';
